import { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import MainPhoto from '@pages/home/cats/MainPhoto';
import AdvantagesBoxCollar from '@pages/home/cats/AdvantagesBoxCollar';
import VideoBoxCollar from '@pages/home/cats/VideoBoxCollar';
import VideoBox from '@pages/home/cats/VideoBox';
import AdvantagesBox from '@pages/home/cats/AdvantagesBox';
import VeterinaryBox from '@pages/home/cats/VeterinaryBox';
import SocialMedia from '@components/social-media/SocialMedia';



const Cats = (): JSX.Element => {

	const collarRef = useRef<HTMLDivElement | null>(null);
	const probeRef = useRef<HTMLDivElement | null>(null);

	
	const scrollToCollar = useCallback(() => {
		collarRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ collarRef ]);

	
	const scrollToProbe = useCallback(() => {
		probeRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ probeRef ]);

	
	return (
		<div className='home-content cats-page'>
			
			<MainPhoto scrollToCollar={scrollToCollar} scrollToProbe={scrollToProbe}/>

			<div className='info-box' ref={collarRef}>
				<h1>POOPERAČNÍ LÍMEC PRO KOČKU</h1>
				<p>VETlímce pro&nbsp;kočky vyvíjíme ve&nbsp;spolupráci s&nbsp;veterinárními lékaři tak, aby&nbsp;splňovaly stejné standardy psích límců a&nbsp;naplnily Vaše očekávání. Pracujeme proto nyní na&nbsp;tom, aby&nbsp;zdravotní límce přinášely kočkám maximální komfort a&nbsp;bezpečí s&nbsp;ohledem na&nbsp;jejich povahu a&nbsp;obratnost. Jedině tak budou naše VETlímce pro&nbsp;kočky novým standardem pooperační péče a&nbsp;léčby či&nbsp;prevence v&nbsp;případě chronických potíží. Věříme, že&nbsp;i&nbsp;Vaše&nbsp;kočka si&nbsp;zaslouží víc!</p>
			</div>

			<AdvantagesBoxCollar />

			<VideoBoxCollar />

			<div className='order-button-box'>
				<Link to={NavigateRoutesEnum.catOrder} className='app-main-button disable-selection'>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>


			<div className='info-box' ref={probeRef}>
				<h1>GASTRO LÍMEC JÍCNOVÁ SONDA</h1>
				<p>GASTRO límec je určen pro&nbsp;kočičí pacienty s&nbsp;jícnovou sondou. GASTRO límec jsme vyvinuli dle&nbsp;konkrétních zkušeností a&nbsp;požadavků veterinárních lékařů tak, aby&nbsp;život kočky se&nbsp;zavedenou jícnovou sondou byl pro&nbsp;kočku co&nbsp;nejvíce pohodlný. Tento zdravotní límec současně maximálně usnadňuje ošetřování kočky, související manipulaci a&nbsp;je vyráběn v&nbsp;různých velikostech dle&nbsp;individuálních potřeb kočky. Věříme, že&nbsp;i&nbsp;Vaše kočka si&nbsp;zaslouží víc!</p>
			</div>

			<VideoBox />

			<AdvantagesBox />

			<VeterinaryBox />

			<div className='order-button-box'>
				<Link to={NavigateRoutesEnum.partners} className='app-main-button disable-selection'>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>

			<SocialMedia />

		</div>
	);
};

export default Cats;